import React, { useCallback, useContext, useEffect, useState } from "react";
import { Transition, Dialog } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Field, useFormik } from "formik";
import * as Yup from "yup";
import { getData, putData } from "actions";
import { API_URL_mergeTicket, API_URL_ticket } from "constants/api";
import { agentReducers } from "redux/agentSlice";
import { ticketReducers } from "redux/ticketSlice";
import { teamReducers } from "redux/teamSlice";
import { toast } from "react-toastify";
import axios from "axios";
import { slicingWord } from "utils/slicingWord";
import { AuthContext } from "context/AuthContext";

const ModalMergeTicket = ({ isOpen, onClose, item, callback }) => {
  const cancelButtonRef = React.useRef(null);
  const { datauser, updateCountTicket, setUpdateCountTicket } = useContext(
    AuthContext
  );
  const [ipAddress, setIpAddress] = useState("0.0.0.0");

  const formik = useFormik({
    initialValues: {
      title: "",
      parent: "",
      reason: "",
    },
    validationSchema: Yup.object({
      parent: Yup.string().required("Parent is required"),
    }),
    onSubmit: (values) => {
      values["ticket"] = item;
      values["agent"] = datauser.id;
      values["ip_address"] = ipAddress;

      axios({
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
        },
        method: "POST",
        data: values,
        url: API_URL_mergeTicket,
      })
        .then((response) => {
          setUpdateCountTicket(!updateCountTicket);
          toast.success("Ticket Merge Successfully", {
            position: "top-center",
            autoClose: true,
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          callback();
          onClose();
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.response?.data.message, {
            position: "top-center",
            autoClose: true,
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        });
    },
  });

  return (
    <Transition.Root show={isOpen} as={React.Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        initialFocus={cancelButtonRef}
        onClose={onClose}
      >
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-start justify-center p-4">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-al w-full lg:w-1/2">
                <form onSubmit={formik.handleSubmit}>
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="mt-3 sm:ml-4 sm:mt-0">
                      <div className="flex justify-between">
                        <Dialog.Title
                          as="h3"
                          className="text-2xl font-semibold leading-6 text-gray-900"
                        >
                          Merge Ticket
                        </Dialog.Title>
                        <button
                          type="button"
                          className=" bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                          onClick={onClose}
                        >
                          X
                        </button>
                      </div>

                      <hr className="my-2" />

                      <div className="px-6 py-1">
                        <label htmlFor="link" className="block mb-1">
                          Title
                        </label>
                        <input
                          type="text"
                          id="title"
                          name="title"
                          placeholder="Optional"
                          className="w-full p-2 border border-gray-300 rounded-md"
                          value={formik.values.title}
                          onChange={formik.handleChange}
                        />
                      </div>

                      <div className="px-6 py-1">
                        <label htmlFor="link" className="block mb-1">
                          Select Parent Ticket
                          <span className="text-red-500">*</span>
                        </label>
                        <select
                          id="parent"
                          name="parent"
                          value={formik.values.parent}
                          onChange={formik.handleChange}
                          className="block w-full rounded-md border border-gray-500 bg-white py-2 px-2 text-gray-900 shadow-sm focus:ring-1 focus:ring-inset focus:ring-blue-400 sm:text-sm sm:leading-6"
                        >
                          <option value="">Select</option>
                          {item &&
                            item.map((item, index) => (
                              <option key={index} value={item.id}>
                                {item.title && item.title}
                              </option>
                            ))}
                        </select>
                        {formik.touched.parent && formik.errors.parent && (
                          <div className="text-red-500 dark:text-red-300 text-xs">
                            {formik.errors.parent}
                          </div>
                        )}
                      </div>

                      <div className="px-6 py-1">
                        <label htmlFor="link" className="block mb-1">
                          Reason For Merging
                        </label>
                        <textarea
                          id="reason"
                          name="reason"
                          className="w-full p-2 border border-gray-300 rounded-md"
                          value={formik.values.reason}
                          onChange={formik.handleChange}
                        >
                          {formik.values.reason}
                        </textarea>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 flex justify-between px-4 py-3 sm:px-6">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                      onClick={onClose}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="inline-flex justify-center rounded-md bg-sky-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-600"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ModalMergeTicket;
